export default {
    namespaced: true,
    state: {
        collapse: false,
    },
    actions: {
        /**
         * 设置侧边栏展开或者收缩
         * @param {Object} context
         * @param {Boolean} collapse is collapse
         */
        async collapseSet({
            state
        }, collapse) {
            // store 赋值
            state.collapse = collapse
        },
        /**
         * 切换侧边栏展开和收缩
         * @param {Object} context
         */
        async collapseToggle({
            state
        }) {
            // store 赋值
            state.collapse = !state.collapse
        },
    },
    mutations: {}
}